export default "__VITE_ASSET__ZGscA5ZV__"